import api from '../../api/index.js';
import author from './actions.js';
import ui from '../ui/actions.js';

import mapping from '~/utils/mapping.json';

import { toVertexLogoURL } from '~/utils/transform.js';


// =============================================================================
// Utils
// =============================================================================
const transformResults = results => results.map(({
    id, name, logo_id, logo_url,
}) => ({
    id,
    name,
    logo_url: toVertexLogoURL({ logo_id, logo_url }),
}));

// =============================================================================
// GET
// =============================================================================
export const fetchAuthor = id => async (dispatch) => {

    try {
        // console.log('author stuff meta', id)
        const res = await dispatch(api.get(`/users/${id}`));

        const { data: { name, logo_id, logo_url } } = res;
        // console.log("author details: ", data)

        dispatch(author.set({
            id,
            name,
            logo_url: toVertexLogoURL({ logo_id, logo_url }),
        }));

    } catch (error) {
        dispatch(ui.flash.error({ header: 'Fetch author failed' }));
    }
};

export const searchAuthor = (e, { searchQuery }) => async (dispatch) => {

    dispatch(author.fetching.on());

    if (searchQuery.length === 0) {
        dispatch(author.search.results.clear());
        dispatch(author.fetching.off());
        return;
    }
    if (searchQuery.length < 3) {
        return dispatch(author.search.results.clear({ message: 'Minimum 3 character' }));
    }

    try {
        const res = await dispatch(api.get('/search', {
            params: {
                types: mapping.vertex_types.by_name.USER,
                email_terms: true,
                terms: searchQuery,
                limit: 15,
            },
        }));

        dispatch(author.search.results.set(transformResults(res.data.results)));
        dispatch(author.fetching.off());

    } catch (error) {
        dispatch(author.search.results.clear({ message: 'Error: somthing went wrong' }));
        dispatch(author.fetching.off());
    }
};
